import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "open-container-filter" }, null, -1)
const _hoisted_2 = { class: "open-container-textbox" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "open-container-logo" }, null, -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "open-container-button" }

import { ref, computed, watch, nextTick } from "vue";
import { useRoute } from "vue-router";
import { useLanguage } from "@/composables/useLanguage";


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenContainer',
  setup(__props) {

const route = useRoute();
const { t } = useLanguage();

const containerEl = ref<HTMLElement | null>(null);

// Map route names to GYM image numbers (images are in public/media/).
const bgMap: Record<string, string> = {
  home: "7",
  contacts: "5",
  about: "9",
  product: "16",
  gallery: "15",
  buy: "1",
};

const currentView = computed(() => {
  const name = (route.name as string | undefined)?.toLowerCase() ?? "home";
  return bgMap[name] ? name : "home";
});

const bgImage = computed(
  () => `/media/GYM${bgMap[currentView.value]}.jpg`
);

const locationText = computed(
  () =>
    (t.value.OpenContainer[0] as Record<string, string>)[currentView.value] ??
    ""
);

const titleText = computed(
  () =>
    (t.value.OpenContainer[1] as Record<string, string>)[currentView.value] ??
    ""
);

// On every route change: scroll to top and fade the container in.
watch(currentView, () => {
  window.scrollTo(0, 0);
  nextTick(() => {
    containerEl.value?.animate(
      [
        { filter: "brightness(0)", offset: 0 },
        { filter: "brightness(1)", offset: 1 },
      ],
      { duration: 400, iterations: 1 }
    );
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "open-container",
    id: "openContainerBackground",
    ref_key: "containerEl",
    ref: containerEl,
    style: _normalizeStyle({ backgroundImage: `url(${bgImage.value})` })
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(), _createElementBlock("div", {
        class: "open-container-location revealDiv",
        key: 'loc-' + currentView.value
      }, _toDisplayString(locationText.value), 1)),
      (_openBlock(), _createElementBlock("div", {
        class: "open-container-title revealDiv",
        key: 'title-' + currentView.value,
        innerHTML: titleText.value
      }, null, 8, _hoisted_4)),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          class: "default-button-container",
          to: "/buy"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t).Navbar[4]), 1)
          ]),
          _: 1
        })
      ])
    ])
  ], 4))
}
}

})